import z from 'zod';
import { scopedEntity, string } from '../common';
export const contact = z.object({
    name: string,
    phone: string.nullable(),
    email: string.nullable(),
});
export const contactList = z.object({
    ...scopedEntity.shape,
    name: string,
    description: string.nullable().default(null),
    contacts: contact.array(),
});
